<p-pickList [source]="availableGroup" [target]="selectedGroup" 
    [showSourceControls]="false" 
    [showTargetControls]="false" 
    [showSourceFilter]="showSourceFilter" 
    [showTargetFilter]="showTargetFilter" 
    filterBy="ItemId,ItemDisplay"
    sourceHeader="Available Asset IDs"
    targetHeader="Selected Asset IDs"
    sourceFilterPlaceholder="{{loading ? 'Loading..' : 'Search by ID/Name'}}" 
    targetFilterPlaceholder="{{loading ? 'Loading..' : 'Search by ID/Name'}}"
    required="true"
    name="AssetGroup"
    [dragdrop]="true"
    [disabled]= "disableAssetGroup"
	  (onMoveToTarget)="change()"
    (onMoveToSource)="change()"
    [responsive]="true">
    
    <ng-template let-group pTemplate="item">
      <div class="ui-helper-clearfix ui-picklist1 ui-picklist-list1">
      <div>{{group.ItemId}} - {{group.ItemDisplay}}</div>
      </div>
    </ng-template>
</p-pickList>